export default __webpack_public_path__ + "static/media/misc-bathtubA-1440w.7463e04b.avif";